import styled from "styled-components";
import { FlexColumn, FlexRow } from "styles/layout";

export const PageContent = styled.div`
  padding: 6px 8px 6px 8px;
`;

export const ColumnContainer = styled(FlexRow)`
  column-gap: 20px;
  align-items: flex-start;
`;

export const Column = styled(FlexColumn)<{ hideUnderWidth?: number }>`
  align-items: stretch;

  @media (max-width: ${({ hideUnderWidth }) => hideUnderWidth ?? 0}px) {
    display: none;
  }
`;

export const GrowColumn = styled(Column)`
  flex-grow: 1;
  justify-content: stretch;
  width: 100%;
`;

export const InfoH3 = styled.h3`
  margin: 0;
`;

export const InfoP = styled.p`
  margin: 0 0 20px 0;
`;

export const InfoUL = styled.ul`
  margin: -15px 0 20px 0;
`;

export const InfoHeaderSubtext = styled.span`
  font-size: 12pt;
  font-weight: 600;
  font-style: italic;
  margin-left: 4px;
  color: dimgray;
`;
